import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CountryService} from './api/country.service';
import {Country} from './api/country';
import {upperCase} from 'lodash';

@Component({
    selector: 'ftl-country',
    template: `
        <span [title]="getCountryDescription()">{{ country?.name }}</span>
    `
})
export class CountryComponent implements OnChanges {

    /* Country identifiers */
    @Input('country-id') countryId: number;
    @Input('country-code') countryCode: string;

    private country: Country;

    constructor(private _countryService: CountryService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.hasOwnProperty('countryId')) {
            this.update({id: changes['countryId'].currentValue});

        } else if (changes.hasOwnProperty('countryCode')) {
            this.update({abbreviation: upperCase(changes['countryCode'].currentValue)});
        }
    }

    getCountryDescription(): string {
        if (!!this.country) {
            return `
                ISO Code: ${this.country.abbreviation}\nAllow payment: ${this.country.allow_payment}
            `
        }
    }

    private update(query: Country | any) {
        this._countryService
            .findFirstCountryBy(query)
            .subscribe(country => this.country = country);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/components/dictionary/country/country.component.ts